import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { debounce, get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { compose } from 'recompose'

import moment from 'moment'
import { wizard } from 'helpers/decorators'
import { Title, Button, FormDebug } from 'components/misc'
import { nextLevel } from 'constants/wizards'
import validate from './details.validation'
import {
  apiCodeLists,
  apiConfiguration,
  apiCommon
} from 'helpers/decorators/api'
import { Checkbox } from 'components/fields'
import { Address, PersonalDetails } from 'components/forms'
import getParticipantAge from 'helpers/getParticipantAge'
import { CONFIGURATION_KEYS } from 'constants/enums'

const enhance = compose(
  apiConfiguration(),
  apiCodeLists(['genders', 'titles', 'employmentStatuses', 'nationalities'], {
    public: true
  }),
  apiCommon({
    publicCountries: true
  }),
  wizard({
    form: 'nextLevelRegistration',
    multipage: true,
    destroyOnUnmount: false,
    validate
  })
)

class Details extends Component {
  static propTypes = {
    configuration: PropTypes.object,
    codeLists: PropTypes.object,
    handleSubmit: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    changeWizardActive: PropTypes.func.isRequired,
    changeWizardNext: PropTypes.func.isRequired,
    links: PropTypes.array,
    change: PropTypes.func.isRequired,
    errors: PropTypes.object,
    values: PropTypes.object,
    common: PropTypes.object,
    onGetConfigurationValue: PropTypes.func.isRequired,
    isConfigurationTrue: PropTypes.func.isRequired
  }
  static defaultProps = {}

  constructor(props) {
    super(props)
    this.handleWizardUpdate = debounce(this.handleWizardUpdate, 1000)
    this.state = {}
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.values && get(prevProps, 'values.birthDate')) {
      this.handleWizardUpdate(null, this.props.values.birthDate)
      return
    }

    if (
      get(this.props, 'values.birthDate') !== get(prevProps, 'values.birthDate')
    ) {
      this.handleWizardUpdate(
        get(prevProps, 'values.birthDate'),
        get(this.props, 'values.birthDate')
      )
    }
  }

  handleWizardUpdate = (oldValue, newValue) => {
    const { steps, rootPath } = nextLevel
    const { links } = this.props
    const profile =
      links && links.findEntry(item => item.id === steps.profile.id)
    const payment =
      links && links.findEntry(item => item.id === steps.payment.id)

    if (oldValue !== newValue) {
      if (
        moment().diff(newValue, 'years') <
        getParticipantAge(this.props.configuration)
      ) {
        this.props.changeWizardActive(steps.parent.id, true)
        this.props.changeWizardNext(
          steps.details.id,
          rootPath + steps.parent.path
        )
        this.props.change('helpers.isUnderAge', true)
      } else {
        this.props.change('helpers.isUnderAge', false)
        this.props.changeWizardActive(steps.parent.id, false)

        let nextActive = steps.profile.path

        if (profile[1].active) {
          nextActive = steps.profile.path
        } else if (payment[1].active) {
          nextActive = steps.payment.path
        }

        this.props.changeWizardNext(steps.details.id, rootPath + nextActive)
      }
    }
  }

  render() {
    const {
      handleSubmit,
      codeLists,
      onSubmit,
      change,
      values,
      common
    } = this.props

    const showPostalAddress = this.props.isConfigurationTrue(CONFIGURATION_KEYS.postalAddress.id)
    const showTitle = this.props.isConfigurationTrue(CONFIGURATION_KEYS.participantRegistrationTitle.id)
    const showMiddleName = this.props.isConfigurationTrue(CONFIGURATION_KEYS.participantRegistrationMiddleName.id)
    const showNationality = this.props.isConfigurationTrue(CONFIGURATION_KEYS.participantRegistrationNationality.id)
    const showEmplStatus = this.props.isConfigurationTrue(CONFIGURATION_KEYS.participantRegistrationEmplStatus.id)
    const showAddressLine1 = this.props.isConfigurationTrue(CONFIGURATION_KEYS.participantRegistrationAddressLine1.id)
    const showAddressLine2 = this.props.isConfigurationTrue(CONFIGURATION_KEYS.participantRegistrationAddressLine2.id)
    const showCity = this.props.isConfigurationTrue(CONFIGURATION_KEYS.participantRegistrationAddressCity.id)
    const showZipCode = this.props.isConfigurationTrue(CONFIGURATION_KEYS.participantRegistrationAddressZipCode.id)
    const showRegion = this.props.isConfigurationTrue(CONFIGURATION_KEYS.participantRegistrationAddressRegion.id)
    const showCountry = this.props.isConfigurationTrue(CONFIGURATION_KEYS.participantRegistrationAddressCountry.id)

    const postalAddressChecked = get(values, 'helpers.postalAddressChecked')

   // const showHomeAddress = showAddressLine1 || showAddressLine2 || showCity || showZipCode || showRegion || showCountry


    return (
      <form onSubmit={handleSubmit(onSubmit)}>
        <Title h1>
          <FormattedMessage
            id="moduleTitle.personal_details"
            defaultMessage="Personal Details"
          />
        </Title>

        <PersonalDetails
          titles={codeLists.titles.list}
          nationalities={showNationality ? codeLists.nationalities.list : undefined}
          employmentStatuses={showEmplStatus ? codeLists.employmentStatuses.list : undefined}
          genders={codeLists.genders.list}
          change={change}
          errors={this.props.errors}
          showTitle={showTitle}
          showMiddleName={showMiddleName}
        />

        <div>
          <Title h2>
            <FormattedMessage
              id="moduleTitle.home_address"
              defaultMessage="Home Address"
            />
          </Title>
          <Address
            optionalState
            showFirstLine={showAddressLine1}
            showSecondLine={showAddressLine2}
            showCity={showCity}
            showZipCode={showZipCode}
            showRegion={showRegion}
            showCountry={showCountry}
            countries={common.countries.list}
          />
        </div>

        {showPostalAddress && (
          <div>
            <Checkbox
              name="helpers.postalAddressChecked"
              intlKey="label.postal_address_different"
              label="My postal address is different"
            />
          </div>
        )}
        {showPostalAddress && postalAddressChecked && (
          <div>
            <Title h2>
              <FormattedMessage
                id="moduleTitle.postal_address"
                defaultMessage="Postal Address"
              />
            </Title>
            <Address
              prefix="postal"
              countries={common.countries.list}
            />
          </div>
        )}

        <FormDebug {...this.props} />
        <Button>
          <FormattedMessage id="button.continue" defaultMessage="Continue" />
        </Button>
      </form>
    )
  }
}

export default enhance(Details)
